import axiosInstance from "services/AxiosInstance";
import { TFeatureFlagAccount } from "types";

export const putFeatureFlagAccountService = async (accountId: string, featureFlag: TFeatureFlagAccount) => {
  const response = await axiosInstance.put(`featureflags/${accountId}`, featureFlag);
  return response.data;
};
